// ── rrDates — RR-UX-1 S1: ONE shared date treatment for the Vendor + Org Risk Responses lists ──
//
// Extracted from OrgRenewalChainGroup (RR-BI-1 / Slice 2a) so vendor + org render dates IDENTICALLY.
//   • ACTUAL date, en-GB "12 Mar 2026" — NEVER relative (no formatDistanceToNow).
//   • Expires carries a subtle urgency PILL — ⚠ thresholds FROZEN: ms<0 → lapsed/rose · ms≤30d → amber ·
//     else a plain understated date. null Expires = "No expiry" (a REAL non-Accept state, never an em dash).
//   • ⚠ RR-UX-1 typography tune: understated (text-xs, tabular-nums, aligned) — a notch smaller than 2a.

import type { ReactNode } from 'react';

export function fmtDate(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

// Approved — the actual approved date, or a caller-supplied fallback for the unapproved case (org passes none
// → an em dash; vendor passes its per-state label e.g. "Awaiting Approval").
export function ApprovedCell({ iso, fallback }: { iso: string | null; fallback?: ReactNode }) {
  if (!iso) return <>{fallback ?? <span className="text-xs text-text-faint">—</span>}</>;
  return <span className="text-xs font-medium text-text-primary tabular-nums">{fmtDate(iso)}</span>;
}

// Expires — actual date + urgency pill (thresholds FROZEN), else a plain understated date; null = "No expiry".
export function ExpiresCell({ iso }: { iso: string | null }) {
  if (!iso) return <span className="text-xs italic text-text-faint">No expiry</span>;
  const ms = new Date(iso).getTime() - Date.now();
  const day = 86_400_000;
  const date = fmtDate(iso);
  if (ms < 0) {
    return <span className="inline-flex items-center rounded bg-accent-rose/10 px-1.5 py-0.5 text-xs font-semibold text-accent-rose tabular-nums">{date}</span>;
  }
  if (ms <= 30 * day) {
    return <span className="inline-flex items-center rounded bg-accent-amber/10 px-1.5 py-0.5 text-xs font-semibold text-accent-amber tabular-nums">{date}</span>;
  }
  return <span className="text-xs font-medium text-text-primary tabular-nums">{date}</span>;
}
